export const CREDENTIAL_LOG_IN_REQUEST = 'auth/CREDENTIAL_LOG_IN_REQUEST'
export const PROVIDER_LOG_IN_REQUEST = 'auth/PROVIDER_LOG_IN_REQUEST'
export const LOG_IN_REQUEST = 'auth/LOG_IN_REQUEST'
export const LOG_IN_ERROR = 'auth/LOG_IN_ERROR'
export const CLEAR_LOG_IN_ERROR = 'auth/CLEAR_LOG_IN_ERROR'
export const LOG_IN_SUCCESS = 'auth/LOG_IN_SUCCESS'

export const LOG_OUT = 'auth/LOG_OUT'

export const HEADER_ENRICHMENT_LOG_IN_REQUEST = 'auth/HEADER_ENRICHMENT_LOG_IN_REQUEST'
